import { ArmourFactory } from "./armour-factory";
import { EquipmentItem } from "./equipment-item";
import { GearFactory } from "./gear-factory";
import { WeaponFactory } from "./weapon-factory";

export class EquipmentFactory {
    public static getAllEquipment(): EquipmentItem[] {
        const allEquipment = WeaponFactory.getAllWeapons()
            .concat(ArmourFactory.getAllArmour())
            .concat(GearFactory.getGear());
        return allEquipment;
    }
}